<template>
  <page-view :title="false">
    <a-card :bordered="false">
      <a-tabs type="card" @change="callback"
        ><a-tab-pane
          :key="item.code"
          :tab="item.name"
          v-for="item in tabList"
        ></a-tab-pane
      ></a-tabs>
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="App标识"
                ><a-input v-model="queryParam.appId" placeholder="App标识"
              /></a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="版本号"
                ><a-input v-model="queryParam.version" placeholder="版本号"
              /></a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="否是最新">
                  <a-select
                    v-model="queryParam.isNew"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="1">是</a-select-option>
                    <a-select-option value="0">否</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="状态">
                  <a-select
                    v-model="queryParam.sta"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="R">待发布</a-select-option>
                    <a-select-option value="I">已发布</a-select-option>
                    <a-select-option value="X">已下架</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button class="button-margin-left" @click="rest"
                  >重置</a-button
                >

                <a-button
                  type="primary"
                  icon="plus"
                  @click="add"
                  class="button-margin-left"
                  v-hasAnyPermission="`appversion:add`"
                  >新建</a-button
                >

                <a @click="toggleAdvanced" class="button-margin-left">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 数据表格 -->
      <s-table
        ref="table"
        rowKey="id"
        :columns="columns"
        :data="loadData"
        showPagination="auto"
        :scroll="{ x: 2000 }"
      >
        <span slot="tagItem" slot-scope="text, record">
          <template>
            {{ text }}
            <a-tag class="render-tag" v-if="record.isNew == 'T'" color="#108ee9"
              >新版本</a-tag
            >
            <a-tag class="render-tag" color="#f50" v-if="record.isForced == 'T'"
              >强制更新</a-tag
            >
            <a-tag
              class="render-tag"
              color="#87d068"
              v-if="record.browser == 'T'"
              >浏览器可下载</a-tag
            >
          </template>
        </span>
        <span slot="sta" slot-scope="text">
          <template>
            <a-tag
              class="render-tag"
              :color="
                text == 'R' ? '#393D49' : text == 'I' ? '#87d068' : 'grey'
              "
            >
              {{ text == "R" ? "待发布" : text == "I" ? "已发布" : "已下架" }}
            </a-tag>
          </template>
        </span>
        <span slot="content" slot-scope="text">
          <template>
            <div v-html="text"></div>
          </template>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a
              class="a-action"
              @click="action(record, 'edit')"
              v-hasAnyPermission="`appversion:edit`"
              >编辑</a
            >

            <a-popconfirm
              title="确认删除?"
              v-if="record.sta != 'I'"
              @confirm="action(record, 'del')"
              okText="确认"
              cancelText="取消"
              v-hasAnyPermission="`appversion:delete`"
            >
              <a class="a-action">删除</a>
            </a-popconfirm>

            <a-popconfirm
              title="确认发布?"
              v-if="record.sta == 'R'"
              @confirm="action(record, 'I')"
              okText="确认"
              cancelText="取消"
              v-hasAnyPermission="`appversion:release`"
            >
              <a class="a-action">发布</a>
            </a-popconfirm>

            <a-popconfirm
              title="确认下架?"
              v-if="record.sta == 'I'"
              @confirm="action(record, 'X')"
              okText="确认"
              cancelText="取消"
              v-hasAnyPermission="`appversion:down`"
            >
              <a class="a-action">下架</a>
            </a-popconfirm>
          </template>
        </span>
      </s-table>
    </a-card>
    <app-version-info
      ref="appModal"
      @success="$refs.table.refresh(true)"
    ></app-version-info>
  </page-view>
</template>

<script>
import moment from "moment";
import { STable } from "@/components";
import { PageView } from "@/layouts";
import AppVersionInfo from "./AppVersionInfo.vue";

export default {
  name: "AppVersionList",
  components: {
    STable,
    PageView,
    AppVersionInfo
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      tabList: [
        { name: "安卓", code: "android" },
        { name: "苹果", code: "ios" }
      ],
      tabKey: "android",
      // 查询参数
      queryParam: {
        plat: "android"
      },
      // 表头
      columns: [
        {
          title: "App标识",
          dataIndex: "appId",
          fixed: "left"
        },
        {
          title: "版本号",
          dataIndex: "version",
          scopedSlots: { customRender: "tagItem" },
          width: 100,
          fixed: "left"
        },
        {
          title: "内部版本号",
          dataIndex: "insideVersion",
          width: 120,
          fixed: "left"
        },
        {
          title: "发布状态",
          dataIndex: "sta",
          scopedSlots: { customRender: "sta" },
          width: 100,
          fixed: "left"
        },
        {
          title: "升级内容",
          dataIndex: "content",
          scopedSlots: { customRender: "content" },
          width: 500
        },
        {
          title: "安装包地址",
          dataIndex: "packageUrl",
          width: 600
        },
        {
          title: "操作人",
          dataIndex: "modifyUser",
          width: 100
        },
        {
          title: "更新时间",
          dataIndex: "modifyDatetime",
          width: 200
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "left",
          fixed: "right",
          width: 120,
          scopedSlots: { customRender: "action" }
        }
      ],
      //加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return this.$http.roomBksApi
          .pageAppVersion(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.resultObject;
          });
      }
    };
  },
  created() {},
  methods: {
    /**
     * 操作
     * @param {Object} record
     * @param {Object} type
     */
    action(record, type) {
      if (type == "edit") {
        this.$refs.appModal.showModal(type, Object.assign({}, record));
      } else if (type == "del") {
        this.$http.roomBksApi
          .deleteAppVersionStaById({ id: record.id })
          .then(res => {
            if (res.result == 0) {
              this.$refs.table.refresh(true);
              this.$message.success(res.msg);
            }
          });
      } else if (type == "I" || type == "X") {
        this.$http.roomBksApi
          .modifyAppVersionStaById({ id: record.id, sta: type })
          .then(res => {
            if (res.result == 0) {
              this.$refs.table.refresh(true);
              this.$message.success(res.msg);
            }
          });
      }
    },
    add() {
      this.$refs.appModal.showModal("add", { plat: this.tabKey });
    },
    /**
     * 展开/收起查询条件
     */
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    callback(key) {
      this.tabKey = key;
      this.queryParam.plat = key;
      this.$refs.table.refresh(true);
    },
    rest() {
      this.queryParam = {};
      this.queryParam.plat = this.tabKey;
    }
  }
};
</script>
